import { useParams } from "react-router-dom"
import useFetch from "../utils/useFetch";
import { FetchURL } from "../utils/url";
import Loading from "../components/Loading";
import SingleProduct from "../components/Products/singleProduct";

const CategoryProducts = () => {
    let {name} = useParams();
    
    const { data, loading } = useFetch(FetchURL)

    const products = data?.products?.filter(item => item.category === name)

    if(loading) return <Loading />

    return(
        <>
            <div className="relative overflow-hidden px-6 py-32 md:px-12 lg:px-20">
            <div className="grid md:grid-cols-4 md:gap-3 gap-1 grid-cols-2 md:w-[80%] md:ml-[10%] w-[95%] ml-[2.5%]">
            {products && products.map((item) => (
            <SingleProduct key={item.id} item={item} />
            ))}
            </div>
        </div>
        </>
    )
}

export default CategoryProducts